import { render, staticRenderFns } from "./ParsingCv.vue?vue&type=template&id=6b3f15d2"
import script from "./ParsingCv.vue?vue&type=script&lang=js"
export * from "./ParsingCv.vue?vue&type=script&lang=js"
import style0 from "./ParsingCv.vue?vue&type=style&index=0&id=6b3f15d2&prod&lang=scss"
import style1 from "./ParsingCv.vue?vue&type=style&index=1&id=6b3f15d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports